import { apiClient } from "./client";

const GetAll = () => {
  return apiClient
    .get("/PlanAttachment");
}

const GetByKey = (id) => {
  return apiClient
    .get("/PlanAttachment/GetByKey", {
      params: {
        'Id': id
      }
    });
}

const PlanAttachmentDropDown = () => {
  return apiClient
    .get("/PlanAttachment/PlanAttachmentDropDown");
}

const GetForUser = () => {
  return apiClient
    .get("/PlanAttachment/GetForUser");
}

const GetHotelAttachments = (hotelId) => {
  return apiClient
    .get("/PlanAttachment/GetHotelAttachments", {
      params: {
        'hotelId': hotelId
      }
    })
}

const Delete = (id) => {
  return apiClient
    .delete("/PlanAttachment", {
      params: {
        'key': id
      }
    });
}

const Add = (formData) => {
  return apiClient.post('/PlanAttachment', formData)
}

const GetHotelAttachmentsByGroupId = (brokerGroupId, cityConsistency) => {
  return apiClient
    .post("/PlanAttachment/GetHotelAttachmentsByGroupId", {
      "brokerGroupId": brokerGroupId,
      "cityConsistency": cityConsistency
    });
}

const planAttachmentApi = {
  Add, GetAll, GetByKey, PlanAttachmentDropDown, GetForUser
  , Delete, GetHotelAttachments, GetHotelAttachmentsByGroupId
}
export default planAttachmentApi;